<template>
  <div class="container">
    <md-progress-bar md-mode="query" class="md-accent" v-if="loading"></md-progress-bar>
    <div class="md-layout-item md-size-100" v-else>
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-blue">
          <div class="card-icon">
            <md-icon>sort</md-icon>
          </div>
          <h4 class="title">{{ $t("banner.edit.title") }}</h4>
        </md-card-header>

        <md-card-content>
          <md-card>
            <md-card-content>
                <img v-if="bannerModel.url != ''" :src="getBannerURL()" />
                <span v-else class="md-headline">{{$t("banner.edit.notBanner")}}</span>
            </md-card-content>
            <md-card-actions>
                <md-button class="md-simple">
                  <label for="upload-banner">
                    <md-file @md-change="setBanner" name="upload-banner" id="upload-banner" style="display:none"></md-file>
                    <md-icon>edit</md-icon> Editar
                  </label>
                </md-button>
                <md-button class="md-simple md-danger" @click="removeBanner()">
                  <md-icon>close</md-icon> Eliminar
                </md-button>
            </md-card-actions>
          </md-card>
        </md-card-content>
      </md-card>
    </div>
  </div> 
</template>

<script>
import storage from "@/plugins/azure-storage";

export default {
  data() {
    return {
      loading: true,
      bannerModel: {
        url: ''
      }
    }
  },
  async mounted() {
    this.bannerModel.url = await this.$store.dispatch("bannerGet")
    this.loading = false;
  },
  methods: {
    getBannerURL() {
      if (this.bannerModel.url == '') {
        return `${process.env.VUE_APP_CDN_URL_BANNER}default.jpg`
      } 
      return `${process.env.VUE_APP_CDN_URL_BANNER}${this.bannerModel.url}`
    },
    async uploadBanner(FileList) {
      const file = FileList[0];
      return await storage.updateFile({
        file,
        container: process.env.VUE_APP_CDN_CONTAINER_BANNER
      });
    },
    async setBanner(FileList) {
      const response = await this.uploadBanner(FileList)
      this.bannerModel.url = response
      await this.$store.dispatch("bannerSet", {value: this.bannerModel.url})
      this.$notify({
        message: this.$t(`notifications.banner.save`),
        icon: 'add_alert',
        horizontalAlign: 'right',
        verticalAlign: 'bottom',
        type: 'success'
      })
    },
    async removeBanner() {
      await this.$store.dispatch("bannerSet", {value: ''})
      this.bannerModel.url = ""
      this.$notify({
        message: this.$t(`notifications.banner.remove`),
        icon: 'add_alert',
        horizontalAlign: 'right',
        verticalAlign: 'bottom',
        type: 'success'
      })
    }
  }
}
</script>

<style lang="scss">
.md-card .md-card-actions {
  border-top: 0;
}
</style>